<template>
  <div class="healthy-engage-landing-page">
    <!--      Navigation section      -->
    <div class="healthy-engage-navigation">
      <nav class="navbar navbar-expand-lg">
        <button class="navbar-toggler navbar-light pl-0" type="button" @click="toggleMenu" 
        data-toggle="collapse" data-target="#navbarNav">
        <img class="" src="@/assets/image/menu_icon.svg">
        </button>
        <a class="navbar-brand pl-4 d-none d-sm-block" href="#">
          <img class="logo-img" src="@/assets/image/logo-blue.png" alt="healthy engage"><span class="logo-text"> HEALTHY ENGAGE</span>
        </a>
        <a class="navbar-brand d-block d-sm-none ml-auto mr-auto" href="#">
          <img class="nav-image" src="@/assets/image/headerlogo_mob.png" alt="healthy engage">
        </a>
        
        <div class="collapse navbar-collapse justify-content-end" id="navbarNav" :class="{ show : menuCollapsed}">
          <ul class="navbar-nav align-items-baseline">
            <!-- <li class="nav-item">
              <a class="nav-link nav-content" href="#solution">Solutions</a>
            </li>
            <li class="nav-item">
              <a class="nav-link nav-content" href="#whyUs">Why Us?</a>
            </li>
            <li class="nav-item ">
              <a class="nav-link nav-content" href="#integration">Integration</a>
            </li> -->
            <li class="nav-item">
              <span class="d-none d-sm-block"><button class="btn login" @click="pharmaLogin" type="button" >Pharma Login  </button></span>
              <a class="d-block d-sm-none" ><span><button class="nav-link btn nav-content" @click="pharmaLogin" type="button" >Pharma Login  </button></span></a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    
    <!--      Banner section      -->
    <section class="health-care">
      <div class="container-fluid py-md-5">
        <div class="mx-0 p-md-2 row">
          <div class="col pt-4">
            <p class="health-care-title text-center">Reinventing collaboration </p>
            <p class="health-care-title text-center">& experience in healthcare</p>
          </div>
        </div>
        <div class="row justify-content-center mx-0 py-3 py-md-4">
          <a href="#contact"><button class="btn contact"><span class="contact-btn-text">Contact Us</span></button></a>
        </div>
      </div>
    </section>

    <!--      Solution section      -->
    <!-- <section id="solution" class="container solutions">
      <div  class="row mx-0 text-center pt-4 pt-md-5">
        <div class="col col-md">
          <h2 class="solution-title">Solutions
          </h2>
        </div>
      </div>

      <div class="row mx-0 justify-content-center pt-5 ">
        <div class="col-12 col-md-6  text-center">
          <p class="real-time text-capitalize">Near-real time digital</p>
          <p class="real-time text-capitalize">interactions</p>
        </div>
        <div class="col-12 col-md-6 text-center text-capitalize d-none d-sm-block">
          <p class="dynamic-empirical text-capitalize">Dynamic & empirical</p>
          <p class="dynamic-empirical text-capitalize">financial risk estimator</p>
        </div>
      </div>

      <div class="row pt-4 justify-content-center mx-0">
        <div class="col-12 col-md-6 text-center">
          <img class="d-none d-sm-block" src="@/assets/image/solutions_1.svg">
          <img class="d-block d-sm-none" src="@/assets/image/treatment1.svg">
        </div>
        <div class="col-12 col-md-6 text-center d-none d-sm-block">
          <img class="" src="@/assets/image/solutions_2.svg">
        </div>
      </div>

      <div class="row mx-0 justify-content-center pt-5 d-block d-sm-none">
        <div class="col-12 col-md-6 text-center">
          <p class="dynamic-empirical text-capitalize">Dynamic & empirical</p>
          <p class="dynamic-empirical text-capitalize">financial risk estimator</p>
        </div>
        <div class="col-12 col-md-6 text-center pt-4">
          <img class="" src="@/assets/image/financial1.svg">
        </div>
      </div>

      <div class="row mx-0 mt-5 justify-content-center">
        <div class="text-center pb-4 pb-md-5 pt-2">
          <a href="#contact"><button class="btn contact" ><span class="contact-btn-text">Contact Us</span></button></a>
        </div>
      </div>
    </section> -->

    <!--      Why Us section      -->
    <!--  <section id="whyUs"  class="container why-us">
      <div class="row mx-0 text-center pt-5">
        <div class="col col-md">
          <h2 class="solution-title">Why us?
          </h2>
        </div>
      </div>

      <div class="row mx-0 my-4 my-md-5">
        <div class="col-12 col-md-6">
          <div class="row justify-content-center mx-0">
            <div class="col-12 col-md-12 text-center">
              <p class="digital-interaction">Near Real Time Digital</p>
              <p class="digital-interaction">Interactions</p>
            </div>
          </div>

          <div class="row justify-content-center mt-5 mx-0">
            <div class="card card-shadow col-md-10 mb-3 round-card">
              <div class="align-items-center no-gutters row pb-2 pt-2">
                <div class="col-md-2 icon-card">
                  <img src="@/assets/image/drop-off-rates.svg">
                </div>
                <div class="col-md-8 offset-md-1 text-card">
                  Decrease Drop-off Rates (Adherence & Persistence)
                </div>
              </div>
            </div>
          </div>

          <div class="row justify-content-center mt-2 mx-0">
            <div class="card card-shadow col-md-10 mb-3 round-card">
              <div class="align-items-center no-gutters row pb-2 pt-2">
                <div class="col-md-2 icon-card">
                  <img src="@/assets/image/zero-fees.svg">
                </div>
                <div class="col-md-8 offset-md-1 text-card">
                  Zero Implementation Fees
                </div>
              </div>
            </div>
          </div>

          <div class="row justify-content-center mt-2 mx-0">
            <div class="card card-shadow col-md-10 mb-3 round-card">
              <div class="align-items-center no-gutters row pb-2 pt-2">
                <div class="col-md-2 icon-card">
                  <img src="@/assets/image/work-flow.svg">
                </div>
                <div class="col-md-8 offset-md-1 text-card">
                  Embedded in Workflow (OncoEMR Integration)
                </div>
              </div>
            </div>
          </div>

          <div class="row justify-content-center mt-2 mx-0">
            <div class="card card-shadow col-md-10 mb-3 round-card">
              <div class="align-items-center no-gutters row pb-2 pt-2">
                <div class="col-md-2 icon-card">
                  <img src="@/assets/image/improved-intervention.svg">
                </div>
                <div class="col-md-8 offset-md-1 text-card">
                  Improved Intervention
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="col-12 col-md-6 border-left pt-md-0 pt-4 no-left-border">
          <div class="row justify-content-center mx-0" >
            <div class="col-12 col-md-12 text-center">
              <p class="financial-risk">Financial Risk</p>
              <p class="financial-risk">Estimator</p>
            </div>
          </div>

           <div class="row justify-content-center mt-5 mx-0">
            <div class="card card-shadow col-md-10 mb-3 round-card">
              <div class="align-items-center no-gutters row pb-2 pt-2">
                <div class="col-md-2 icon-card">
                  <img src="@/assets/image/revenue-capture.svg">
                </div>
                <div class="col-md-8 offset-md-1 text-card">
                  Improved Revenue Capture
                </div>
              </div>
            </div>
          </div>

          <div class="row justify-content-center mt-2 mx-0">
            <div class="card card-shadow col-md-10 mb-3 round-card">
              <div class="align-items-center no-gutters row pb-2 pt-2">
                <div class="col-md-2 icon-card">
                  <img src="@/assets/image/transparency.svg">
                </div>
                <div class="col-md-8 offset-md-1 text-card">
                  Patient/Guarantor Transparency
                </div>
              </div>
            </div>
          </div>

          <div class="row justify-content-center mt-2 mx-0">
            <div class="card card-shadow  col-md-10 mb-3 round-card">
              <div class="align-items-center no-gutters row pb-2 pt-2">
                <div class="col-md-2 icon-card">
                  <img src="@/assets/image/financial-stability.svg">
                </div>
                <div class="col-md-8 offset-md-1 text-card">
                  Indicators of Financial Stability
                </div>
              </div>
            </div>
          </div>

          <div class="row justify-content-center mt-2 mx-0">
            <div class="card card-shadow col-md-10 mb-3 round-card">
              <div class="align-items-center no-gutters row pb-2 pt-2">
                <div class="col-md-2 icon-card">
                  <img src="@/assets/image/segmentation.svg">
                </div>
                <div class="col-md-8 offset-md-1 text-card">
                  Continuous Segmentation
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </section> -->

    <!--      Integration section      -->
    <!-- <section id="integration" class="integration">
      <div class="container">
        <div  class="row mx-0 text-center pt-4 pt-md-5">
          <div class="col col-md">
            <h2 class="integration-title">Integration
            </h2>
          </div>
        </div>

      <div class="d-none d-sm-block">
        <div class="row justify-content-center mx-0 my-5">
          <div class="col-12 col-md-6 text-center">
            <a href="https://www.linkedin.com/company/flatiron-health"> 
              <img class="img-fluid flat-img" src="@/assets/image/Flatiron_logo.png"></a>
          </div>
          <div class="col-12 col-md-6 text-center">
            <a href="https://www.linkedin.com/company/transunion">
              <img class="img-fluid trans-img float-left ml-4" src="@/assets/image/TransUnion_logo.png"></a>
          </div>
        </div>

        <div class="row mx-0 justify-content-center">
          <div class="col-12 col-md-6">
            <div class="row h-100">
              <div class="col-md-9 offset-md-3 px-0 border-bottom-text">
                <p class="flatron-text">Flatiron Health’s mission is to</p>
                <p class="flatron-text">improve  lives by learning from the</p>
                <p class="flatron-text">experience of every cancer patient.</p>
                <p class="flatron-text"> Please visit our website for our open</p>
                <p class="flatron-text pb-4">positions.</p>
               
              </div>
            </div> 
          </div>
          <div class="col-12 col-md-6 ">
            <div class="row h-100">
              <div class="col-md-9 offset-md-1 px-0 border-bottom-text">
                <p class="flatron-text">TransUnion is a global information</p>
                <p class="flatron-text">and insights company that makes </p>
                <p class="flatron-text">trust possible between businesses </p>
                <p class="flatron-text">and consumers, by ensuring that</p>
                <p class="flatron-text">each consumer is reliably and safely </p>
                <p class="flatron-text pb-4">represented in the marketplace.</p>
               
              </div>
            </div> 
          </div>
        </div>

        <div class="row mx-0 justify-content-center pb-5">
          <div class="col-12 col-md-6">
            <div class="row">
              <div class="col-md-9 offset-md-3 px-0 pt-2">
                <img src="@/assets/image/linked-in-color.svg" alt="healthy linkedin" >
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="row">
              <div class="col-md-9 offset-md-1 px-0 pt-2">
                <img src="@/assets/image/linked-in-color.svg" alt="healthy linkedin" >
              </div>
            </div>            
          </div>
        </div>
      </div>
    
      <div class="d-block d-sm-none">
        <div class="row justify-content-center mx-0 pt-4">

            <div class="text-center">
                <img class="img-fluid flat-img" src="@/assets/image/flatiron_mob.png">
                <div class="px-0 pt-5 border-bottom-text">
                  <p class="flatron-text">Flatiron Health’s mission is to</p>
                  <p class="flatron-text">improve  lives by learning from the</p>
                  <p class="flatron-text">experience of every cancer patient.</p>
                  <p class="flatron-text"> Please visit our website for our open</p>
                  <p class="flatron-text pb-4">positions.</p>
                </div>
                <div class="px-0 pt-2">
                  <a href="https://www.linkedin.com/company/flatiron-health"> <img src="@/assets/image/linked-in-color.svg" class="t" alt="healthy linkedin" ></a>
              </div>
            </div>

            <div class="text-center pt-4">
                <img class="img-fluid trans-img " src="@/assets/image/transunion_mob.png">
                <div class="pt-5 px-0 border-bottom-text" >
                  <p class="flatron-text">TransUnion is a global information</p>
                  <p class="flatron-text">and insights company that makes </p>
                  <p class="flatron-text">trust possible between businesses </p>
                  <p class="flatron-text">and consumers, by ensuring that</p>
                  <p class="flatron-text">each consumer is reliably and safely </p>
                  <p class="flatron-text pb-4">represented in the marketplace.</p>
                </div>
                <div class="px-0 pt-2">
                  <a href="https://www.linkedin.com/company/transunion">
                  <img src="@/assets/image/linked-in-color.svg" class="t" alt="healthy linkedin" >
                  </a>
                </div>
            </div>

          </div>
      </div>
    </div>

    </section> -->

    <!--      Contact section      -->
    <section id="contact" class="contact-form">
      <div class="container">
        <div class="row mx-0 my-4 my-md-5">
          <div class="col-12 col-md-6">
            <h4 class="text-left let-us"> Let us tell you more.</h4>
            <p class="text-left start-conversation"> We will email you to start the conversation.</p>
          </div>
          
          <div class="col-12 col-md-6 pt-md-0 pt-4">
            <form @submit.prevent="saveContact(contact)">
              <div class="form-group">
                <input v-model="contact.name" type="text" class="input-box w-100" placeholder="Name" required>
              </div>

              <div class="form-group">
                <input type="email" v-model="contact.email" v-validate="'required'" :class="{'danger': errors.has('email') }" class="input-box w-100" placeholder="Email" required>
              </div>

              <div class="form-group">
                <input type="text" v-model="contact.company" class="input-box w-100" placeholder="Company" required>
              </div>

              <div class="d-none d-sm-block pt-3">
                <b-button type="submit" class="btn submit px-5" ><span class="submit-btn-text">Submit</span></b-button>
              </div>

              <div class=" d-block d-sm-none pt-3 text-center">
                <b-button type="submit" class="btn submit" ><span class="submit-btn-text">Submit</span></b-button>
              </div>
              
              <div v-if="isSent">
                <h4> We will be in touch soon. </h4>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!--      Botom section      -->
    <section class="container-fluid py-3"> 
      <div class="row mx-3 align-items-center">
        
        <div class="col-12 col-md-6 d-none d-sm-block">
          <img src="@/assets/image/logo-blue.png" class="" alt="healthy engage"><span class="logo-text"> HEALTHY ENGAGE</span>
        </div>
        <div class="col-12 col-md-6 d-none d-sm-block">
           <a href="https://www.linkedin.com/organization-guest/company/healthy-engage?challengeId=AQFUeKz7zo0sVwAAAXModC-mn4VRjHptjuKSTbcmaLX5yuhJVea4To7NDPE1K9brkHvvP6YYYPemm7e-8OX_mwJUrSDRxikLvg&submissionId=f8ee1ace-066c-1f16-0403-22292dbdd067">
           <img src="@/assets/image/linked-in-color.svg" class="float-right" alt="healthy linkedin" ></a>
        </div>
      </div>

      <div class="row mx-1 my-2 align-items-center d-block d-sm-none">
        <img src="@/assets/image/footerlogo_mob.png" class="" alt="healthy engage">
        <a class="logo-link" href="https://www.linkedin.com/organization-guest/company/healthy-engage?challengeId=AQFUeKz7zo0sVwAAAXModC-mn4VRjHptjuKSTbcmaLX5yuhJVea4To7NDPE1K9brkHvvP6YYYPemm7e-8OX_mwJUrSDRxikLvg&submissionId=f8ee1ace-066c-1f16-0403-22292dbdd067">
           <img src="@/assets/image/linked-in-color.svg" alt="healthy linkedin" ></a>
      </div>
    </section>
    
  </div> 
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  /**
   * The name of the page.
   */
  name: 'LandingPage',
  data() {
    return {
      contact: {
        name: null,
        email: null,
        company: null
      },
      menuCollapsed: false
    };
  },
  computed: {
    ...mapGetters({
      isSent: 'user/isSent'
    })
  },
  methods: {

    /**
     * Provides the contact details to save.
     */
    saveContact(contact) {
      this.$validator.validateAll().then(() => {
        this.$store.dispatch('user/requestDemo', contact);
      });
    },

    /**
     * Route to login page.
     */
    customerLogin() {
      Vue.router.push({
      name: 'login.index'
    });
    },

    /**
     * Route to meet application login page.
     */
    pharmaLogin() {      
      window.open("https://meet.healthyengage.net", "_blank");
    },

    /**
     * Will toggle the menu.
     */
    toggleMenu() {
      this.menuCollapsed = !this.menuCollapsed;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
